export const THEME_QUERY_PARAM_NAME = 'theme'